import { MenuItem } from '@companycam/slab-web';
import React from 'react';
import styled from 'styled-components';

const LayoutAddButtonWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  pointer-events: none;
  & i.mdi {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 45px;
    height: 45px;
    font-size: var(--cc_size_text_xxl);
    background-color: var(--cc_color_background_1);
    border-radius: 1000px;
    box-shadow: 0px var(--cc_size_depth_2_y) var(--cc_size_depth_2_blur) 0px
      var(--cc_color_depth_2);
  }
`;

const LayoutOptionWrapper = styled(MenuItem)`
  &[data-slot='layout-menu-item'] {
    outline: none;
    border: none;
    background: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    position: relative;
    & img[data-slot='layout-menu-item-image'] {
      opacity: 0.6;
      transition: opacity 200ms ease-in-out;
    }

    & ${LayoutAddButtonWrapper} {
      opacity: 0;
      transition: opacity 200ms ease-in-out;
    }

    &:hover img[data-slot='layout-menu-item-image'],
    &:hover ${LayoutAddButtonWrapper} {
      opacity: 1;
    }

    & .layout-add-button {
      pointer-events: none;
      box-shadow: 0px var(--cc_size_depth_2_y) var(--cc_size_depth_2_blur) 0px
        var(--cc_color_depth_2);
    }
  }
`;

export const LayoutOption = (props: {
  src: string;
  accessibilityLabel: string;
  'data-testid': string;
  onClick: () => void;
  disabled?: boolean;
}) => {
  const { src, accessibilityLabel, onClick, disabled } = props;

  return (
    <LayoutOptionWrapper
      data-slot="layout-menu-item"
      data-testid={props['data-testid']}
      onClick={onClick}
      disabled={disabled}
    >
      <img
        data-slot="layout-menu-item-image"
        src={src}
        alt={accessibilityLabel}
      />
      <LayoutAddButtonWrapper>
        <i className="mdi mdi-plus" data-slot="layout-menu-item-icon" />
      </LayoutAddButtonWrapper>
    </LayoutOptionWrapper>
  );
};
